import React from "react";

function Revenue() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 472 472"
    >
      <path
        fill="#f98500"
        d="M128 408h80v32h-80zm-112 0h80v32H16zm256 0h80v32h-80zm112-32h80v32h-80zm-256-32h80v32h-80zm-112 0h80v32H16zm96-64h80v32h-80zm144 64h80v32h-80zm128-32h80v32h-80zm0-64h80v32h-80zm0-64h80v32h-80zm-128 96h80v32h-80zm0 0"
        data-original="#f98500"
      ></path>
      <path
        fill="#ffb531"
        d="M144 376h80v32h-80zm-16-64h80v32h-80zm256 96h80v32h-80zM0 376h80v32H0zm256 0h80v32h-80zm112-32h80v32h-80zm-128-32h80v32h-80zm144-32h80v32h-80zm-16-64h80v32h-80zm16-64h80v32h-80zm-144 96h80v32h-80zm0 0"
        data-original="#ffb531"
      ></path>
      <path
        fill="#b7d341"
        d="M468.488 1.375a8.009 8.009 0 00-7.465-.8l-40 16 5.954 14.863 17.527-7.016-45.36 73.715-24.898-31.13A7.684 7.684 0 00367.711 64a7.995 7.995 0 00-6.305 3.465L278.45 188.137l-49.242-42.211a7.984 7.984 0 00-5.91-1.895 8.012 8.012 0 00-5.488 2.903l-65.954 80.601-41.785-48.734a7.986 7.986 0 00-6.824-2.758 7.993 7.993 0 00-6.191 3.988l-64 112 13.89 7.938 58.399-102.137 40.617 47.367a8.368 8.368 0 006.16 2.801 7.997 7.997 0 006.102-2.938l66.816-81.664 49.785 42.672a8.005 8.005 0 006.242 1.86 7.993 7.993 0 005.559-3.403l81.863-119.113L393.754 117a8.178 8.178 0 006.742 2.984 7.995 7.995 0 006.32-3.793L456 36.261V56h16V8a8.003 8.003 0 00-3.512-6.625zm0 0"
        data-original="#7eb457"
      ></path>
      <path
        fill="#b0564c"
        d="M0 440h464v32H0zm0 0"
        data-original="#b0564c"
      ></path>
    </svg>
  );
}

export default Revenue;
